// There is no store review prompt on web, so callers show their own fallback.
export const isAvailableAsync = async () => false;
export const requestReview = async () => { };
